import { Flex } from '@sendoutcards/quantum-design-ui'
import React, { FC } from 'react'
import { useSelector } from 'src/hooks'
import { Tab, TabProps } from './Tab'

type TabBarProps = {
  children?: React.ReactNode
  tabs: TabProps[]
  activeTabIndex: number
  barBackgroundColor?: string
  activeTabBackgroundColor?: string
  activeTabTextColor?: string
  barBoxShadow?: string
  radius?: string
  height?: string
  tabTextSize?: string
  tabInsetVertical?: string
  shouldHideText?: boolean
  shouldTabsFillWidth?: boolean
}

export const TabBar: FC<TabBarProps> = ({
  tabs,
  activeTabIndex,
  radius = '100px',
  height = '62px',
  activeTabBackgroundColor,
  activeTabTextColor,
  barBackgroundColor = '#f5f6f7',
  barBoxShadow,
  tabTextSize,
  tabInsetVertical,
  children,
  shouldHideText = false,
  shouldTabsFillWidth = false,
}) => {
  const shouldTightenNavDividerSpacing = useSelector(
    state => state.window.width <= 420,
  )

  return (
    <Flex style={{ overflow: 'visible' }}>
      <Flex
        rowGap="x2"
        justifyContent="flex-start"
        backgroundColor={barBackgroundColor}
        inset="x_75"
        style={{
          borderRadius: radius,
          boxShadow: barBoxShadow,
          overflow: 'visible',
        }}
        height={height}
      >
        {tabs.map((tab, index) => {
          return (
            <Flex
              key={`${tab.title}-${index}`}
              width={shouldTabsFillWidth ? undefined : 'auto'}
              alignItems="center"
              style={
                shouldTabsFillWidth
                  ? { flex: 1, minWidth: 0 }
                  : { flexShrink: 0 }
              }
            >
              {tab.showLeftDivider ? (
                <div
                  aria-hidden="true"
                  style={{
                    width: 1,
                    height: 26,
                    backgroundColor: '#D1D5DB',
                    margin: shouldTightenNavDividerSpacing ? '0' : '0 10px',
                    borderRadius: 1,
                  }}
                />
              ) : null}
              <Tab
                icon={tab.icon}
                radius={radius}
                isActive={index === activeTabIndex}
                notificationCount={tab.notificationCount}
                hideText={tab.hideText}
                activeTabBackgroundColor={activeTabBackgroundColor}
                activeTabTextColor={activeTabTextColor}
                tabBarBackground={barBackgroundColor}
                textSize={tabTextSize}
                insetVertical={tabInsetVertical}
                title={tab.title}
                shouldHideText={shouldHideText}
                onClick={tab.onClick}
              />
            </Flex>
          )
        })}
      </Flex>
      {children}
    </Flex>
  )
}
